<template>
  <div>

    <TitlePage :title="$t('reviews')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler" :delete-permission="false"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 align-center">
        <v-col cols="12" md="3" class="pt-2 pb-2" v-if="getUser.super_admin">
          <CenterSelectSearch
              v-model="filter.center_id"
              :multiple="false"
              :includeAllOption="true"
              autoStrategy="user"
              :returnObject="false"
              @message="(val) => filter.center_id = val"
          />
        </v-col>
        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>

      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.user_fullname="{ item }">
          <template v-if="item.user_fullname">
            <template v-if="isSuperAdmin">
              <router-link target="_blank" rel="noopener"
                           v-if="item.user_id"
                           :to="`/customers/details/${item.user_id}`"
              >
                <strong>{{ item.user_fullname }}</strong>
              </router-link>
            </template>
            <template v-else>
              {{ item.user_fullname }}
            </template>
          </template>
          <template v-else>
            N.D.
          </template>
        </template>

        <template v-slot:item.center="{ item }">
          <template v-if="item.center[0]">
            <template v-if="isSuperAdmin">
              <router-link target="_blank" rel="noopener"
                           v-if="item.center[0]._id"
                           :to="`/centers?_id=${item.center[0]._id}`"
              >
                {{ item.center[0].name }}
              </router-link>
            </template>
            <template v-else>
              {{ item.center[0].name }}
            </template>
          </template>
          <template v-else>
            N.D.
          </template>
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleString() }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.active" inset @change="updateSingleStatus(item)" dense hide-details class="mt-0" :readonly="!getUser.super_admin"></v-switch>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>
                  Visualizza/Gestisci
                </v-list-item-title>
              </v-list-item>
              <!--              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')">-->
              <!--                <v-list-item-title>-->
              <!--                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>-->
              <!--                  {{ $t('delete') }}-->
              <!--                </v-list-item-title>-->
              <!--              </v-list-item>-->
            </v-list>
          </v-menu>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>

    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";

const exportService = require('@/services/export')

export default {
  name: 'Reviews',
  components: {CenterSelectSearch, ItemActions, ModalDelete, TitlePage, CenterAutocomplete},
  data() {
    return {
      pathCreate: '/reviews/create/',
      pathEdit: '/reviews/edit/',
      search: '',
      selected: [],
      headers: [
        // { text: this.$t('Id'), align: 'start', value: '_id'},
        {text: this.$t('sportsCenter'), value: 'center'},
        {text: this.$t('customer'), align: 'start', value: 'user_fullname'},
        {text: this.$t('vote'), value: 'vote'},
        {text: this.$t('status'), value: 'status', sortable: false},
        {text: this.$t('creation_date'), value: 'created_at'},
        {text: this.$t('actions'), align: 'start', value: 'action',},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      statuses: [
        {text: "", value: ""},
        {text: "Prenotata", value: "booked"},
        {text: "Completata", value: "completed"},
        {text: "Da pagare", value: "to_be_payed"},
        {text: "Cancellata", value: "canceled"},
        {text: "Rimborsata", value: "refunded"},
        {text: "Interrotta", value: "interrupted"},
        {text: "In Attesa", value: "pending"},
        {text: "Da Confermare", value: "to_be_confirmed"},
      ],
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100]
    };
  },
  async created() {
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)
    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(); }, 350);
  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
      'getFilter':'reviews/getFilter',
      'getOptionsPagination':'reviews/getOptionsPagination',
    }),
    isSuperAdmin(){
      return (this.getUser && this.getUser.super_admin) ? this.getUser.super_admin : false;
    },
  },
  watch: {
    filter: {
      handler() {
        this._debouncedSearch();
      },
      deep: true
    },
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'reviews/index',
      'deleteItem': 'reviews/delete',
      'updateItem': 'reviews/update',
      'massiveDeleteItem': 'reviews/massDelete',
      'setFilter': 'reviews/setFilter',
      'setOptionsPagination': 'reviews/setOptionsPagination',
    }),

    debounce(fn, wait){
      var t=null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },

    async resetFilter(){
      var filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }
      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id) {
      this.$router.push(this.pathEdit + id)
    },

    confirmRemove(id) {
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove() {
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode) {
      if (this.typeDelete == 'single') {
        await this.remove(mode)
      } else if (this.typeDelete == 'massive') {
        await this.massiveRemove(mode)
      } else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode) {

      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id: this.ids_to_delete[0]})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode) {
      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id: {$in: this.ids_to_delete}})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async getNewPage() {
      await this.makeSearch()
    },
    calculatePagination(count, limit) {

      var divide = (count / limit)
      var rest = divide % 1

      if (rest > 0) {
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    async setCenterId(id) {
      this.filter.center_id = id
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {active: item.active}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
